import { useEffect, useMemo, useState } from "react";
import { Card, CardContent } from "../../../../components/ui/Card";
import { Badge } from "../../../../components/ui/Badge";
import LotCard from "../../../../components/ui/LotCard";
import backendApi from "../../../utils/BackendApi";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import {
  Drawer,
  TextField,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  Autocomplete
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Container } from '@mui/material';
import { CircularProgress } from "@mui/material";
import { FaSpinner } from 'react-icons/fa';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { saveAs } from "file-saver";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import { useNavigate, useLocation } from "react-router-dom";


const WORKERS_API = "/api/production/workers";
const CONFIRMED_ORDERS_API = "/api/production/confirmed";

export default function ProductionAssignment() {
  const [orders, setOrders] = useState([]);
  const [lotOrders, setLotOrders] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [assignedWorkers, setAssignedWorkers] = useState([]);
  const [protocolNumber, setProtocolNumber] = useState("");
  const [search, setSearch] = useState("");
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [loadingLots, setLoadingLots] = useState(true);
  const [saving, setSaving] = useState(false);

  const [filterStatus, setFilterStatus] = useState("SENZA_LOTTO");
  const [filterLotto, setFilterLotto] = useState("");
  const [lotSearch, setLotSearch] = useState("");
  const [lotsCollapsed, setLotsCollapsed] = useState(false);

  const [availablePdfs, setAvailablePdfs] = useState([]);
  const [selectedPdfs, setSelectedPdfs] = useState([]);

  const [pdfExportLoading, setPdfExportLoading] = useState(false);
  const [excelExportLoading, setExcelExportLoading] = useState(false);

  const [uploadNote, setUploadNote] = useState("");
  const [uploading, setUploading] = useState(false);
  const [drawerOrders, setDrawerOrders] = useState([]);
  const [lockedLotto, setLockedLotto] = useState(null);
  const [openingDrawer, setOpeningDrawer] = useState(false);
  const [removingOrderKey, setRemovingOrderKey] = useState(null);

  const [showAddOrders, setShowAddOrders] = useState(false);
  const [additionalOrders, setAdditionalOrders] = useState([]);
  const [loadingAdditionalOrders, setLoadingAdditionalOrders] = useState(false);
  const [selectedAdditionalOrders, setSelectedAdditionalOrders] = useState([]);
  const [additionalOrdersSearch, setAdditionalOrdersSearch] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  // Upload multiplo con nota per ogni file
  const [newFiles, setNewFiles] = useState([]);
  /*
    Struttura:
    [
      {
        file: File,
        note: ""
      }
    ]
  */




  // FILTRI DATA
  const today = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(today.getDate() - 7);

  const [dateFrom, setDateFrom] = useState(oneWeekAgo.toISOString().split("T")[0]);
  const [dateTo, setDateTo] = useState(today.toISOString().split("T")[0]);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [lottoLoaded, setLottoLoaded] = useState(false);
  const [cuttingListLoading, setCuttingListLoading] = useState(false);
  const [cuttingOrderId, setCuttingOrderId] = useState(null);

  const handleOrderCuttingList = async (order) => {
    if (!order.idDocumento || cuttingOrderId != null) return;
    setCuttingOrderId(order.idDocumento);
    try {
      await backendApi.post(
        `/api/production/ordine/${order.idDocumento}/cutting-list`,
        null, { params: { idUtente: 36 } }
      );
      toast.success(`Lista di taglio creata per OC ${order.numDoc}`);
      await loadDocumentsBySelectedOrders(drawerOrders.length ? drawerOrders : [order]);
    } catch (error) {
      toast.error(typeof error.response?.data === "string"
        ? error.response.data : "Errore durante la generazione della lista di taglio OC");
    } finally {
      setCuttingOrderId(null);
    }
  };

  const orderCuttingButton = (order) => String(order.tipoDoc).toUpperCase() === "OC" && (
    <IconButton
      size="small"
      title={`Genera lista di taglio OC ${order.numDoc}`}
      aria-label={`Genera lista di taglio OC ${order.numDoc}`}
      disabled={cuttingOrderId != null || !order.idDocumento}
      onClick={(event) => { event.stopPropagation(); handleOrderCuttingList(order); }}
    >
      {cuttingOrderId === order.idDocumento
        ? <CircularProgress size={18} />
        : <ContentCutIcon fontSize="small" />}
    </IconButton>
  );

  const handleCuttingList = async () => {
    if (!protocolNumber) {
      toast.error("Lotto non disponibile");
      return;
    }

    try {
      setCuttingListLoading(true);
      const response = await backendApi.post(
        `/api/production/lotto/${encodeURIComponent(protocolNumber)}/cutting-list`,
        null,
        { params: { idUtente: 36 } }
      );
      const result = response.data;
      await loadDocumentsBySelectedOrders(drawerOrders);
      toast.success(
        `Lista di taglio creata e collegata a ${result.uploadedDocuments} OC`
      );
    } catch (error) {
      console.error("Errore generazione lista di taglio:", error);
      toast.error("Errore durante la generazione della lista di taglio");
    } finally {
      setCuttingListLoading(false);
    }
  };

  useEffect(() => {
    if (location.state?.fromLotSelection) {
      // piccolo delay per coprire apertura drawer
      const timer = setTimeout(() => {
        // segnala che la UI è pronta
        window.dispatchEvent(new Event("lot-drawer-ready"));
      }, 300);

      return () => clearTimeout(timer);
    }
  }, []);

  const lottoFromUrl =
    new URLSearchParams(location.search)
      .get("lotto");

  useEffect(() => {
    loadOrders(filterStatus);
    loadProductionLots();
    loadWorkers();
  }, []);

  useEffect(() => {
    if (
      lottoLoaded ||
      !lottoFromUrl ||
      loadingLots ||
      lotOrders.length === 0
    ) {
      return;
    }
    openLottoFromUrl();
  }, [
    lottoFromUrl,
    loadingLots,
    lotOrders,
    lottoLoaded
  ]);

  const handleFilterChange = (event) => {
    const newValue = event.target.value;
    setFilterStatus(newValue);
    loadOrders(newValue); // passo direttamente il nuovo stato
  };

  const loadOrders = async (stato) => {
    try {
      setLoadingOrders(true);
      const res = await backendApi.get(CONFIRMED_ORDERS_API, { params: { stato } });
      setOrders(Array.isArray(res.data) ? res.data : []);
      // RESET SELEZIONI
      setSelectedOrders([]);
      setSelectedAdditionalOrders([]);
      setDrawerOrders([]);
    } catch (err) {
      console.error(err);
      toast.error("Errore nel caricamento ordini");
    } finally {
      setLoadingOrders(false);
    }
  };

  const loadProductionLots = async () => {
    try {
      setLoadingLots(true);
      const res = await backendApi.get(CONFIRMED_ORDERS_API, {
        params: {
          stato: "CON_LOTTO"
        }
      });

      setLotOrders(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      toast.error("Errore caricamento lotti");
    } finally {
      setLoadingLots(false);
    }
  };

  const loadWorkers = async () => {
    try {
      const res = await backendApi.get(WORKERS_API);
      setWorkers(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setWorkers([]);
      toast.error("Errore caricamento operai");
    }
  };

  const handleWorkerChange = (event, values) => {
    setAssignedWorkers(values);
  };

  const handleSave = async () => {

    // ⛔ BLOCCO: nessun operaio selezionato
    if (!assignedWorkers || assignedWorkers.length === 0) {
        toast.warning("Seleziona almeno un operaio prima di salvare");
        return;
    }

    try {
      setSaving(true);
      const currentUser = localStorage.getItem("email");
      // Costruisco il body in base al DTO
      const body = {
        ordini: drawerOrders.map((o, index) => ({
          anno: o.anno,
          idCliente: o.idCliente,
          tipoDoc: o.tipoDoc,
          dataDoc: o.dataDoc,
          numDoc: o.numDoc,
          idDocumento: o.idDocumento,
          idProduzione: o?.idProduzione || null,
          sortOrder: index + 1
        })),
        operai: assignedWorkers.map(w => w.code),
        utenteAssegnazione: currentUser,
        lotto: protocolNumber,
        documenti: selectedPdfs
      };

      await backendApi.post(`/api/production/assign`, body);

      // reset selezione SOLO se tutto è andato bene
      setSelectedOrders([]);
      setDrawerOrders([]);

      // aggiorna lista ordini
      loadOrders(filterStatus);
      loadProductionLots();

      setDrawerOpen(false);
      toast.success("Produzione assegnata con successo!");
    } catch (err) {
      console.error(err);
      toast.error("Errore durante l'assegnazione.");
    }finally {
         setSaving(false); // 🔓 riabilita il bottone
       }
  };

  const filteredOrders = orders.filter(o => {
    const searchLower = search.toLowerCase();

    // 🔍 Ricerca libera
    const matchSearch =
      String(o.numDoc).toLowerCase().includes(searchLower) ||
      String(o.idCliente).toLowerCase().includes(searchLower) ||
      (o.tipoDoc || "").toLowerCase().includes(searchLower) ||
      (o.ragioneSocialeCliente || "").toLowerCase().includes(searchLower);

    // 📅 Normalizza tutte le date a mezzanotte per evitare slittamenti
    const normalize = (d) => {
      const x = new Date(d);
      x.setHours(0, 0, 0, 0);
      return x;
    };

    const orderDate = normalize(o.dataPrevCons1);
    const from = normalize(dateFrom);
    const to = normalize(dateTo);

    const matchDate = orderDate >= from && orderDate <= to;

    // 🔁 FILTRO STATO (DA DEFINIRE QUANDO HO LA LOGICA)
//    const matchStatus = filterStatus
//      ? (
//          filterStatus === "SENZA_LOTTO"
//            ? !o.lotto
//            : filterStatus === "CON_LOTTO"
//              ? !!o.lotto
//              : true
//        )
//      : true;

    // 🔖 FILTRO LOTTO (controlla se il testo inserito appare nel lotto)
    const matchLotto = filterLotto
      ? (o.lotto || "").toString().includes(filterLotto)
      : true;

    return matchSearch && /*matchStatus &&*/ matchLotto && matchDate;
  });

  const filteredAdditionalOrders = useMemo(() => {
    const searchLower = additionalOrdersSearch.trim().toLowerCase();

    if (!searchLower) {
      return additionalOrders;
    }

    return additionalOrders.filter(order => {
      const searchableValues = [
        order.tipoDoc,
        order.numDoc,
        `${order.tipoDoc || ""} ${order.numDoc || ""}`,
        `${order.tipoDoc || ""}-${order.numDoc || ""}`,
        order.idCliente,
        order.ragioneSocialeCliente
      ];

      return searchableValues.some(value =>
        String(value || "").toLowerCase().includes(searchLower)
      );
    });
  }, [additionalOrders, additionalOrdersSearch]);

  const productionLots = useMemo(() => {
    const grouped = lotOrders.reduce((acc, order) => {
      if (!order.lotto) return acc;

      if (!acc[order.lotto]) {
        acc[order.lotto] = [];
      }

      acc[order.lotto].push(order);
      return acc;
    }, {});

    return Object.entries(grouped)
      .map(([lotto, ordini]) => {
        const clienti = new Set(ordini.map(o => o.idCliente));
        const operai = new Set(ordini.flatMap(o => o.operai || []));
        const prossimaConsegna = ordini
          .filter(o => o.dataPrevCons1)
          .sort(
            (a, b) =>
              new Date(a.dataPrevCons1) -
              new Date(b.dataPrevCons1)
          )[0];

        return {
          lotto,
          ordini,
          numeroOrdini: ordini.length,
          numeroClienti: clienti.size,
          operai: [...operai],
          prossimaConsegna: prossimaConsegna?.dataPrevCons1 || null
        };
      })
      .filter(lot =>
        lot.lotto
          .toLowerCase()
          .includes(lotSearch.toLowerCase())
      )
      .sort((a, b) => b.lotto.localeCompare(a.lotto));
  }, [lotOrders, lotSearch]);

//  const availableOrdersToAdd = orders.filter(o => {
//    // senza lotto
//    const noLotto = !o.lotto;
//
//    // non già selezionato
//    const notAlreadySelected = !drawerOrders.some(
//      d => d.idDocumento === o.idDocumento
//    );
//
//    // NON in lavorazione
//    const notWorking =
//      o.stato !== "PRODOTTO" &&
//      o.stato !== "CONFEZIONAMENTO" &&
//      o.stato !== "CONSEGNA" &&
//      o.stato !== "PARTITO";
//
//    return noLotto && notAlreadySelected && notWorking;
//  });

const availableOrdersToAdd = async () => {
  try {
    const res = await backendApi.get(CONFIRMED_ORDERS_API, {
      params: { stato: "SENZA_LOTTO" }
    });

    return res.data.filter(o => {
      // senza lotto
      const noLotto = !o.lotto;

      // non già selezionato
      const notAlreadySelected =
        !drawerOrders.some(d => d.idDocumento === o.idDocumento);

      // NON in lavorazione
      const notWorking =
        o.stato !== "PRODOTTO" &&
        o.stato !== "CONFEZIONAMENTO" &&
        o.stato !== "CONSEGNA" &&
        o.stato !== "PARTITO";

      return noLotto && notAlreadySelected && notWorking;
    });
  } catch (err) {
    console.error(err);
    toast.error("Errore caricamento ordini disponibili");
    return [];
  }
};

  const handleTogglePdf = (pdfId) => {
    setSelectedPdfs(prev =>
      prev.includes(pdfId)
        ? prev.filter(id => id !== pdfId)
        : [...prev, pdfId]
    );
  };

  const formatOrderReference = (order) => {
    if (!order) return "";

    return [order.tipoDoc, order.numDoc]
      .filter(value => value !== undefined && value !== null && String(value).trim() !== "")
      .join(" ");
  };

  const getPdfOrderReference = (pdf) => {
    if (pdf?.ordineAssociato) return pdf.ordineAssociato;

    const matchingOrder = drawerOrders.find(
      order => String(order.idDocumento) === String(pdf?.idDocumento || pdf?.idEntita)
    );

    return formatOrderReference(matchingOrder);
  };

  const loadDocumentsBySelectedOrders = async (orders) => {
    try {
      const requests = orders.map(o =>
        backendApi.get("/api/documents/byIdDocumento", {
          params: {
            idDocumento: o.idDocumento,
            idProduzione: o.idProduzione || null
          }
        })
      );

      const results = await Promise.all(requests);

      const merged = results.flatMap((r, index) => {
        const order = orders[index];
        const ordineAssociato = formatOrderReference(order);

        return (r.data || []).map(doc => ({
          ...doc,
          idDocumento: doc.idDocumento || doc.idEntita || order?.idDocumento,
          ordineAssociato
        }));
      });

      // elimina duplicati per id
      const unique = Array.from(
        new Map(merged.map(d => [d.id, d])).values()
      );

      setAvailablePdfs(unique);
      setSelectedPdfs(unique.filter(pdf => pdf.assegnato).map(pdf => pdf.id));

    } catch (err) {
      console.error(err);
      toast.error("Errore nel caricamento documenti");
    }
  };

  const loadDocumentsByProduzione = async (idProduzione) => {
    try {
      const res = await backendApi.get("/api/documents/byProduzione", {
        params: { idProduzione }
      });
      console.log("DOCUMENTI CARICATI PER PRODUZIONE:", res.data);
      setAvailablePdfs(res.data || []);
      setSelectedPdfs(res.data?.filter(pdf => pdf.assegnato).map(pdf => pdf.id) || []);
    } catch (err) {
      console.error(err);
      toast.error("Errore nel caricamento documenti");
    }
  };

  const handleUnassign = async () => {
    // 🔹 1. controllo base
    if (selectedOrders.length === 0) return;

    // 🔹 2. estraggo lotti selezionati
    const lotti = [...new Set(
      drawerOrders.map(o => o.lotto).filter(Boolean)
    )];

    // 🔥 controllo coerenza lotti
    if (lotti.length > 1) {
      toast.error("Gli ordini selezionati appartengono a lotti diversi");
      return;
    }

    const lotto = lotti[0];

    if (!lotto) {
      toast.warning("Nessun lotto da annullare");
      return;
    }

    // 🔹 3. conferma utente
    const confirm = window.confirm(
      "Sei sicuro di voler annullare l'assegnazione di questo lotto?"
    );
    if (!confirm) return;

    try {
      setSaving(true);

      await backendApi.delete(`/api/production/lotto/${lotto}`, {
        headers: {
          "X-User": localStorage.getItem("email")
        }
      });

      toast.success("Assegnazione annullata con successo");

      setDrawerOpen(false);
      setSelectedOrders([]);
      loadOrders(filterStatus);
      loadProductionLots();

    } catch (err) {
      console.error(err);
      toast.error("Errore durante l'annullamento");
    } finally {
      setSaving(false);
    }
  };

  // 🔹 Funzione di utilità per convertire date in formato YYYY-MM-DD
  const handleRemoveOrderFromLotto = async (order) => {
    const lotto = order?.lotto || protocolNumber;

    if (!lotto || !order?.idDocumento) {
      toast.warning("Impossibile rimuovere: lotto o documento non disponibile");
      return;
    }

    const confirm = window.confirm(
      `Rimuovere l'ordine ${order.tipoDoc} ${order.numDoc} dal lotto ${lotto}?`
    );

    if (!confirm) return;

    const removingKey = `${lotto}-${order.idDocumento}`;

    try {
      setRemovingOrderKey(removingKey);

      await backendApi.delete(
        `/api/production/lotto/${encodeURIComponent(lotto)}/ordine/${order.idDocumento}`,
        {
          headers: {
            "X-User": localStorage.getItem("email")
          }
        }
      );

      const remainingOrders = drawerOrders.filter(
        o => o.idDocumento !== order.idDocumento
      );

      setDrawerOrders(remainingOrders);
      setSelectedOrders(remainingOrders);
      setNewFiles(prev =>
        prev.filter(file => file.idDocumento !== order.idDocumento)
      );

      await Promise.all([
        loadOrders(filterStatus),
        loadProductionLots()
      ]);

      if (remainingOrders.length > 0) {
        await loadDocumentsBySelectedOrders(remainingOrders);
      } else {
        setAvailablePdfs([]);
        setSelectedPdfs([]);
        setDrawerOpen(false);
      }

      toast.success("Ordine rimosso dal lotto");

    } catch (err) {
      console.error(err);
      toast.error("Errore durante la rimozione dell'ordine dal lotto");
    } finally {
      setRemovingOrderKey(null);
    }
  };

  const isoToLocalDate = (iso) => {
    if (!iso) return "-";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "-";
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };

  // 🔹 Esporta in Excel
  const exportFilteredExcel = () => {
    if (filteredOrders.length === 0) {
      toast.warning("⚠️ Nessun ordine da esportare");
      return;
    }

    setExcelExportLoading(true);

    try {
      // Converte gli ordini in formato tabellare
      const worksheet = XLSX.utils.json_to_sheet(
        filteredOrders.map(o => ({
          "Tipo Documento": o.tipoDoc || "-",
          "Numero Documento": o.numDoc || "-",
          "Cliente": o.idCliente ? `${o.idCliente} - ${o.ragioneSocialeCliente || "-"}` : "-",
          "Rif. Ordine Cliente": o.rifOrdCli || "-",
          "Consegna Prevista": o.dataPrevCons1 ? isoToLocalDate(o.dataPrevCons1) : "-",
          "Lotto": o.lotto || "-",
          "Data Documento": o.dataDoc ? isoToLocalDate(o.dataDoc) : "-"
        }))
      );

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Ordini Filtrati");

      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, `ordini_filtrati_${dateFrom}_${dateTo}.xlsx`);

      toast.success("Excel generato correttamente!");
    } catch (err) {
      console.error(err);
      toast.error("Errore durante la generazione dell'Excel");
    } finally {
      setExcelExportLoading(false);
    }
  };

  // 🔹 Esporta in PDF
  const exportFilteredPdf = () => {
    if (filteredOrders.length === 0) {
      toast.warning("⚠️ Nessun ordine da esportare");
      return;
    }

    setPdfExportLoading(true);

    try {
      const doc = new jsPDF("landscape");
      doc.setFontSize(14);
      doc.text(`Ordini filtrati (${dateFrom} - ${dateTo})`, 14, 15);

      const tableData = filteredOrders.map(o => [
        o.tipoDoc || "-",
        o.numDoc || "-",
        o.idCliente ? `${o.idCliente} - ${o.ragioneSocialeCliente || "-"}` : "-",
        o.rifOrdCli || "-",
        o.dataPrevCons1 ? isoToLocalDate(o.dataPrevCons1) : "-",
        o.lotto || "-",
        o.dataDoc ? isoToLocalDate(o.dataDoc) : "-"
      ]);

      autoTable(doc, {
        head: [["Tipo Doc", "Num Doc", "Cliente", "Rif. Ordine", "Consegna Prevista", "Lotto", "Data Doc"]],
        body: tableData,
        startY: 25,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [60, 60, 60] }
      });

      doc.save(`ordini_filtrati_${dateFrom}_${dateTo}.pdf`);
      toast.success("PDF generato correttamente!");
    } catch (err) {
      console.error(err);
      toast.error("Errore durante la generazione del PDF");
    } finally {
      setPdfExportLoading(false);
    }
  };

  const openPdf = async (pdf) => {
    try {
      const res = await backendApi.get(
        `/api/production/storicoReport/${pdf.id}/pdf/preview`,
        {
          responseType: "blob"
        }
      );

      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // 👁️ preview in nuova tab
      window.open(url, "_blank");

    } catch (err) {
      console.error(err);

      if (err.response?.status === 404) {
        toast.warning("PDF non disponibile");
      } else {
        toast.error("Errore nell'apertura del PDF");
      }
    }
  };

   // ---------------- UPLOAD PDF ----------------

   const handleFileSelection = (event) => {
     const files = Array.from(event.target.files);

     const onlyPdf = files.filter(f => f.type === "application/pdf");

     if (onlyPdf.length !== files.length) {
       toast.warning("Sono ammessi solo file PDF");
     }

     const mapped = onlyPdf.map(file => ({
       file,
       note: "",
       idDocumento: selectedOrders[0]?.idDocumento || ""
     }));

     setNewFiles(prev => [...prev, ...mapped]);

     // reset input per permettere ri-selezione stesso file
     event.target.value = null;
   };

    const handleDocumentoChange = (index, value) => {
      setNewFiles(prev =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                idDocumento: value
              }
            : item
        )
      );
    };

    const closeDrawer = () => {

      setDrawerOpen(false);

      setNewFiles([]);
      setSelectedPdfs([]);
      setAvailablePdfs([]);

      setSelectedAdditionalOrders([]);
      setAdditionalOrders([]);
      setLoadingAdditionalOrders(false);
      setAdditionalOrdersSearch("");
      setShowAddOrders(false);

      setSelectedOrders([]);
      setDrawerOrders([]);
      setAssignedWorkers([]);
      setProtocolNumber("");

      navigate(location.pathname, { replace: true });
    };

   // 🚀 Upload file + salvataggio DB
   const handleUploadReports = async () => {
     if (selectedOrders.length === 0) {
       toast.warning("Nessun ordine selezionato");
       return;
     }

     if (newFiles.length === 0) {
       toast.warning("Seleziona almeno un PDF");
       return;
     }

     try {
       setUploading(true);

       const formData = new FormData();

       newFiles.forEach(item => {
         formData.append("files", item.file);

         if (item.note && item.note.trim() !== "") {
           formData.append("note", item.note);
         }
       });

//       // 🔥 FIX: supporto multi ordine (se backend lo supporta)
//       selectedOrders.forEach(o => {
//         if (o.idDocumento) {
//           formData.append("idDocumento", o.idDocumento);
//         }
//       });

       newFiles.forEach(item => {
         formData.append("idDocumento", item.idDocumento);
       });

       formData.append("idUtente", 36);

       await backendApi.post("/api/production/uploadReport", formData, {
         headers: { "Content-Type": "multipart/form-data" }
       });

       toast.success("PDF caricati con successo");

       // 🔄 reload documenti multi ordine
       await loadDocumentsBySelectedOrders(selectedOrders);

       setNewFiles([]);
       setUploadNote("");

     } catch (err) {
       console.error(err);
       toast.error("Errore durante upload PDF");
     } finally {
       setUploading(false);
     }
   };

    // Modifica nota per singolo file
    const handleNoteChange = (index, value) => {
      setNewFiles(prev =>
        prev.map((item, i) =>
          i === index ? { ...item, note: value } : item
        )
      );
    };

    // Rimuovi file dalla lista prima dell'upload
    const handleRemoveFile = (index) => {
      setNewFiles(prev => prev.filter((_, i) => i !== index));
    };


    const handleOpenDrawer = async () => {
      if (selectedOrders.length === 0) return;

      try {
        setOpeningDrawer(true);

        // 🔥 RESET
        setShowAddOrders(false);
        setSelectedAdditionalOrders([]);
        setLoadingAdditionalOrders(false);
        setAdditionalOrdersSearch("");

        const snapshot = selectedOrders;
        setDrawerOrders(
          [...snapshot].sort(
            (a, b) =>
              (a.sortOrder ?? 9999) - (b.sortOrder ?? 9999)
          )
        );

        const lotti = [...new Set(snapshot.map(o => o.lotto).filter(Boolean))];

        if (lotti.length > 1) {
          toast.error("Gli ordini selezionati hanno lotti diversi");
          return;
        }

        let lotto;

        if (lotti.length === 1) {
          lotto = lotti[0];
        } else {
          const first = snapshot[0];
          const today = new Date().toISOString().split("T")[0];

          const res = await backendApi.get(`/api/production/lotto`, {
            params: {
              data: today
            }
          });

          lotto = res.data;
        }

        setProtocolNumber(lotto);

        const operaiPromise = lotto
          ? backendApi.get(`/api/production/lotto/${lotto}/operai`)
          : Promise.resolve({ data: [] });

        const documentiPromise = loadDocumentsBySelectedOrders(snapshot);

        const [operaiRes] = await Promise.all([
          operaiPromise,
          documentiPromise
        ]);

        setAssignedWorkers(operaiRes.data || []);

        setDrawerOpen(true);

      } catch (err) {
        console.error(err);
        toast.error("Errore apertura assegnazione");
      } finally {
        setOpeningDrawer(false);
      }
    };

    const openLotDrawer = async (lotto) => {
      try {
        setOpeningDrawer(true);
        setShowAddOrders(false);
        setSelectedAdditionalOrders([]);
        setLoadingAdditionalOrders(false);
        setAdditionalOrdersSearch("");

        const selectedLotOrders = Array.from(
          new Map(
            orders
              .concat(lotOrders)
              .map(order => [order.idDocumento, order])
          ).values()
        )
          .filter(o => o.lotto === lotto)
          .sort(
            (a, b) =>
              (a.sortOrder ?? 9999) -
              (b.sortOrder ?? 9999)
          );

        if (selectedLotOrders.length === 0) {
          return;
        }

        setSelectedOrders(selectedLotOrders);
        setDrawerOrders(selectedLotOrders);
        setProtocolNumber(lotto);

        const operaiPromise =
          backendApi.get(
            `/api/production/lotto/${lotto}/operai`
          );

        const documentiPromise =
          loadDocumentsBySelectedOrders(
            selectedLotOrders
          );

        const [operaiRes] =
          await Promise.all([
            operaiPromise,
            documentiPromise
          ]);

        setAssignedWorkers(
          operaiRes.data || []
        );

        setLottoLoaded(true);
        setDrawerOpen(true);

      } catch (err) {

        console.error(err);

        toast.error(
          "Errore caricamento lotto"
        );

      } finally {
        setOpeningDrawer(false);
      }
    };

    const openLottoFromUrl = async () => {
      await openLotDrawer(lottoFromUrl);
    };

    const handleAddOrdersToLotto = async () => {

      if (selectedAdditionalOrders.length === 0) {
        toast.warning("Seleziona almeno un ordine");
        return;
      }

      if (!assignedWorkers || assignedWorkers.length === 0) {
        toast.warning("Seleziona almeno un operaio");
        return;
      }
      try {
        setSaving(true);
        const currentUser = localStorage.getItem("email");
        const body = {
          ordini: selectedAdditionalOrders.map(o => ({
            anno: o.anno,
            idCliente: o.idCliente,
            tipoDoc: o.tipoDoc,
            dataDoc: o.dataDoc,
            numDoc: o.numDoc,
            idDocumento: o.idDocumento,
            idProduzione: o?.idProduzione || null
          })),
          operai: assignedWorkers.map(w => w.code),
          utenteAssegnazione: currentUser,
          lotto: protocolNumber,
          documenti: selectedPdfs
        };
        // stessa API del salvataggio
        await backendApi.post(`/api/production/assign`, body);
        toast.success("Ordini aggiunti al lotto");
        // aggiorna lista drawer
        const updatedOrders = [
          ...drawerOrders,
          ...selectedAdditionalOrders
        ];
        setDrawerOrders(updatedOrders);
        setSelectedAdditionalOrders([]);
        setLoadingAdditionalOrders(false);
        setAdditionalOrdersSearch("");
        setShowAddOrders(false);
        loadOrders(filterStatus);
        loadProductionLots();
      } catch (err) {
        console.error(err);
        toast.error("Errore durante aggiunta ordini");
      } finally {
        setSaving(false);
      }
    };

    const hasExistingLotto = drawerOrders.some(o => !!o.lotto);
    const hasSelectedLotto = selectedOrders.some(o => !!o.lotto);

    const moveOrder = (index, direction) => {
      setDrawerOrders(prev => {
        const newOrders = [...prev];

        const targetIndex =
          direction === "up" ? index - 1 : index + 1;

        if (targetIndex < 0 || targetIndex >= newOrders.length) {
          return prev;
        }

        // swap
        [newOrders[index], newOrders[targetIndex]] = [
          newOrders[targetIndex],
          newOrders[index]
        ];

        // opzionale ma CONSIGLIATO: aggiorna sortOrder locale
        return newOrders.map((o, i) => ({
          ...o,
          sortOrder: i + 1
        }));
      });
    };


  return (
    <>
        <Container maxWidth={false}>
          <div style={{ justifyContent: 'left', alignItems: 'left', marginTop: '2rem', gap: '5rem' }}>

            <div
              style={{
                maxWidth: "100%",
                marginBottom: "2rem",
                border: "1px solid #e5e7eb",
                borderRadius: "12px",
                background: "#f9fafb",
                padding: "1rem"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "1rem"
                }}
              >
                <button
                  type="button"
                  onClick={() => setLotsCollapsed(prev => !prev)}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    padding: 0,
                    color: "#111827",
                    textAlign: "left"
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      transform: lotsCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                      fontSize: "1rem"
                    }}
                  >
                    v
                  </span>
                  <span style={{ fontSize: "1.35rem", fontWeight: 700 }}>
                    Lotti produzione
                  </span>
                  <span
                    style={{
                      fontSize: "0.85rem",
                      color: "#6b7280",
                      fontWeight: 500
                    }}
                  >
                    {productionLots.length} lotti
                  </span>
                </button>

                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                  {openingDrawer && (
                    <CircularProgress size={22} />
                  )}
                  <button
                    type="button"
                    onClick={() => setLotsCollapsed(prev => !prev)}
                    style={{
                      border: "1px solid #d1d5db",
                      background: "white",
                      borderRadius: "8px",
                      padding: "0.45rem 0.75rem",
                      cursor: "pointer",
                      fontWeight: 600,
                      color: "#374151"
                    }}
                  >
                    {lotsCollapsed ? "Mostra" : "Nascondi"}
                  </button>
                </div>
              </div>

              {!lotsCollapsed && (
                <>
                  <TextField
                    label="Cerca lotto..."
                    value={lotSearch}
                    onChange={(e) => setLotSearch(e.target.value)}
                    sx={{
                      mt: 2,
                      mb: 2,
                      width: {
                        xs: "100%",
                        sm: "320px"
                      },
                      background: "white"
                    }}
                  />

                  {loadingLots ? (
                    <Card className="rounded-2xl shadow-lg border border-gray-200">
                      <CardContent className="p-6">
                        <p className="text-gray-500 italic">Caricamento lotti...</p>
                      </CardContent>
                    </Card>
                  ) : productionLots.length === 0 ? (
                    <Card className="rounded-2xl shadow-lg border border-gray-200">
                      <CardContent className="p-6">
                        <p className="text-gray-500 italic">Nessun lotto trovato.</p>
                      </CardContent>
                    </Card>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        gap: "0.75rem",
                        overflowX: "auto",
                        overflowY: "hidden",
                        padding: "0.25rem 0 0.75rem",
                        pointerEvents: openingDrawer ? "none" : "auto",
                        opacity: openingDrawer ? 0.6 : 1,
                        scrollbarWidth: "thin"
                      }}
                    >
                      {productionLots.map((lot) => (
                        <LotCard
                          key={lot.lotto}
                          lot={lot}
                          compact
                          onClick={(selectedLot) => openLotDrawer(selectedLot.lotto)}
                        />
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>

            <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
              <button
                  onClick={exportFilteredPdf}
                  style={{
                    backgroundColor: "black",  // sfondo nero
                    color: "white",             // testo bianco
                    padding: "0.5rem 1rem",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  📄 Esporta PDF
              </button>
              <button
                onClick={exportFilteredExcel}
                style={{
                  backgroundColor: "black",  // sfondo nero
                  color: "white",             // testo bianco
                  padding: "0.5rem 1rem",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                📄 Esporta Excel
              </button>
            </div>


            <div style={{ flex: 1, maxWidth: '662px' }}>
                {/* 🔍 Search bar */}
                <TextField
                  label="Cerca ordine..."
                  variant="outlined"
                  fullWidth
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ marginBottom: "1.5rem" }}
                />
            </div>

            <div style={{ display: "flex", gap: "1rem", marginBottom: "1.5rem" }}>

              {/* Stato */}
              <TextField
                label="Stato"
                select
                SelectProps={{ native: true }}
                value={filterStatus}
                onChange={(e) => {
                      const newValue = e.target.value;
                      setFilterStatus(newValue);
                      loadOrders(newValue);  // passo direttamente il nuovo stato
                  }}
                style={{ width: "200px" }}
                InputLabelProps={{ shrink: true }}
              >
                 <option value="">Tutti</option>
                 <option value="SENZA_LOTTO">Senza lotto</option>
                 <option value="CON_LOTTO">Con lotto</option>
                 <option value="PRODOTTO">Prodotto</option>
                 <option value="CONFEZIONAMENTO">Confezionamento</option>
                 <option value="CONSEGNA">Consegna</option>
                 <option value="PARTITO">Partito</option>
              </TextField>

              {/* Lotto */}
              <TextField
                label="Lotto"
                value={filterLotto}
                onChange={(e) => setFilterLotto(e.target.value)}
                style={{ width: "200px" }}
                InputLabelProps={{ shrink: true }}
              />

              {/* Data da */}
              <TextField
                label="Da data"
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />

              {/* Data a */}
              <TextField
                label="A data"
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />

            </div>

            <div style={{ flex: 1, maxWidth: '662px' }}>
                <div
                  style={{
                    marginBottom: "1rem",
                    display: "flex",
                    gap: "0.75rem",
                    alignItems: "center"
                  }}
                >

                  <button
                    disabled={selectedOrders.length === 0 || openingDrawer}
                    onClick={handleOpenDrawer}
                    style={{
                      backgroundColor:
                        selectedOrders.length === 0
                          ? "#9ca3af"
                          : openingDrawer
                          ? "#93c5fd"
                          : "#2563eb",
                      cursor:
                        selectedOrders.length === 0 || openingDrawer
                          ? "not-allowed"
                          : "pointer",
                      color: "white",
                      padding: "0.6rem 1.2rem",
                      borderRadius: "8px",
                      border: "none",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.5rem",
                      boxShadow: "0 4px 12px rgba(37, 99, 235, 0.3)"
                    }}
                  >
                    {openingDrawer ? (
                      <>
                        <CircularProgress size={18} color="inherit" />
                        Caricamento...
                      </>
                    ) : (
                      hasSelectedLotto
                        ? `Modifica ${selectedOrders.length} ordini`
                        : `Assegna ${selectedOrders.length} ordini`
                    )}
                  </button>
                </div>
                {/* 📦 Lista ordini */}
                <Card className="rounded-2xl shadow-lg border border-gray-200">
                  <CardContent className="p-6 space-y-4">

                    {selectedOrders.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginBottom: "0.5rem"
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => setSelectedOrders([])}
                          sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600
                          }}
                        >
                          Deseleziona tutto
                        </Button>
                      </div>
                    )}

                    {loadingOrders ? (
                       <p className="text-gray-500 italic">Caricamento ordini...</p>
                     ) : filteredOrders.length === 0 ? (
                      <p className="text-gray-500 italic">Nessun ordine trovato.</p>
                    ) : (
                      <div className="space-y-3">
                        {filteredOrders.map((order) => (
                          <ListItem
                            key={`${order.idDocumento}-${order.numDoc}-${order.anno}`}
                            disablePadding
                            secondaryAction={
                              <div style={{ display: "flex", alignItems: "center" }}>
                              {orderCuttingButton(order)}
                              <Checkbox
                                edge="end"
                                checked={selectedOrders.some(
                                  o => o.idDocumento === order.idDocumento
                                )}
                                disabled={
                                  (() => {
                                    const hasSelected = selectedOrders.length > 0;
                                    const selectedLotto = selectedOrders.find(o => o.lotto)?.lotto;

                                    // se ho già selezionato qualcosa CON lotto
                                    if (hasSelected && selectedLotto) {
                                      return (
                                        // blocca altri lotti
                                        (order.lotto && order.lotto !== selectedLotto)
                                        // 🔥 blocca anche quelli senza lotto
                                        || !order.lotto
                                      );
                                    }

                                    return false;
                                  })()
                                }
                                onChange={(e) => {
                                  e.stopPropagation();

                                  setSelectedOrders(prev => {
                                    const isSelected = prev.some(o => o.idDocumento === order.idDocumento);

                                    // 🔹 DESELEZIONE
                                    if (isSelected) {
                                      return prev.filter(o => o.idDocumento !== order.idDocumento);
                                    }

                                    // 🔹 SE ORDINE CON LOTTO
                                    if (order.lotto) {
                                      return filteredOrders
                                        .filter(o => o.lotto === order.lotto)
                                        .sort(
                                          (a, b) =>
                                            (a.sortOrder ?? 9999) - (b.sortOrder ?? 9999)
                                        );
                                    }

                                    // 🔹 SE ORDINE SENZA LOTTO
                                    // ⚠️ aggiunge solo se NON c'è già un lotto attivo
                                    const hasLottoSelected = prev.some(o => o.lotto);

                                    if (hasLottoSelected) {
                                      return prev; // blocca selezione incoerente
                                    }

                                    return [...prev, order];
                                  });
                                }}
                              />
                              </div>
                            }
                          >
                            <ListItemButton
                              onClick={() => {
                                console.log("Preview ordine:", order);
                              }}
                              sx={{
                                borderRadius: "12px",
                                paddingRight: "100px",
                                marginBottom: "8px",
                                border: "1px solid #e5e7eb",
                                "&:hover": { backgroundColor: "#f3f4f6" }
                              }}
                            >
                              <ListItemText
                                primary={
                                  <span style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1f2937' }}>
                                    {`${order.tipoDoc} ${order.numDoc}`}
                                  </span>
                                }
                                secondary={
                                  <span style={{ fontSize: '1.2rem', color: '#4B5563' }}>
                                    <div>
                                      Cliente: {order.idCliente}{" "}
                                      {order.ragioneSocialeCliente && (
                                        <> - <b>{order.ragioneSocialeCliente}</b></>
                                      )}
                                    </div>
                                    <div>Doc del {new Date(order.dataDoc).toLocaleDateString("it-IT")}</div>
                                    <div>Rif. Ord. Cli.: {order.rifOrdCli || "-"}</div>
                                    <div>Consegna prevista: {new Date(order.dataPrevCons1).toLocaleDateString("it-IT")}</div>
                                    <div>Lotto: {order.lotto || "-"}</div>
                                  </span>
                                }
                              />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </div>
                    )}
                  </CardContent>
                </Card>
            </div>

            {/* 🔹 DRAWER ASSEGNAZIONE PRODUZIONE */}
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={closeDrawer}
            >
              <div style={{ width: "480px", padding: "2rem" }}>
                <div
                  className="mb-4"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "0.75rem"
                  }}
                >
                  <IconButton
                    onClick={closeDrawer}
                    aria-label="Chiudi dettaglio lotto"
                    sx={{
                      flexShrink: 0,
                      "&:hover": {
                        backgroundColor: "#e0f2fe",
                      }
                    }}
                  >
                    <CloseIcon style={{ fontSize: '30px', color: '#2563eb' }} />
                  </IconButton>

                  <h2
                    className="text-xl font-bold text-indigo-600"
                    style={{ flex: 1, margin: 0 }}
                  >
                    Assegnazione Produzione
                  </h2>

                  <Button
                    variant="contained"
                    size="small"
                    startIcon={
                      cuttingListLoading
                        ? <CircularProgress size={16} color="inherit" />
                        : <ContentCutIcon />
                    }
                    onClick={handleCuttingList}
                    disabled={!protocolNumber || cuttingListLoading}
                    aria-label="Genera la lista di taglio in PDF"
                    sx={{
                      flexShrink: 0,
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      borderRadius: "8px",
                      fontWeight: 600
                    }}
                  >
                    {cuttingListLoading ? "Recupero dati..." : "Lista di taglio"}
                  </Button>
                </div>

                {/* INFO ORDINE */}
                {selectedOrders.length > 0 && (
                  <div className="mb-4 text-gray-700">
                    <p><b>Ordini selezionati:</b></p>

                    {drawerOrders.map((o, index) => {
                      const orderLotto = o.lotto || protocolNumber;
                      const orderRemoveKey = `${orderLotto}-${o.idDocumento}`;
                      const isRemovingOrder =
                        removingOrderKey != null &&
                        removingOrderKey === orderRemoveKey;

                      return (
                      <div
                        key={o.idDocumento}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "0.75rem",
                          marginBottom: "0.5rem",
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          backgroundColor: "white"
                        }}
                      >
                        {/* LEFT: ordine info + posizione */}
                        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>

                          {/* numero posizione */}
                          <div
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              backgroundColor: "#2563eb",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "0.85rem",
                              fontWeight: "bold"
                            }}
                          >
                            {index + 1}
                          </div>

                          <div>
                            <div style={{ fontWeight: 600 }}>
                              {o.tipoDoc}-{o.numDoc}
                            </div>
                            <div style={{ fontSize: "0.85rem", color: "#6b7280" }}>
                              {o.ragioneSocialeCliente}
                            </div>
                          </div>
                        </div>

                        {/* RIGHT: azioni */}
                        <div style={{ display: "flex", alignItems: "center", gap: "0.35rem" }}>
                          {orderCuttingButton(o)}
                          <div style={{ display: "flex", flexDirection: "column" }}>

                            <button
                              onClick={() => moveOrder(index, "up")}
                              disabled={index === 0 || isRemovingOrder}
                              style={{
                                border: "none",
                                background: "transparent",
                                cursor:
                                  index === 0 || isRemovingOrder
                                    ? "not-allowed"
                                    : "pointer",
                                color:
                                  index === 0 || isRemovingOrder
                                    ? "#d1d5db"
                                    : "#111827"
                              }}
                            >
                              <ArrowUpwardIcon fontSize="small" />
                            </button>

                            <button
                              onClick={() => moveOrder(index, "down")}
                              disabled={
                                index === drawerOrders.length - 1 ||
                                isRemovingOrder
                              }
                              style={{
                                border: "none",
                                background: "transparent",
                                cursor:
                                  index === drawerOrders.length - 1 ||
                                  isRemovingOrder
                                    ? "not-allowed"
                                    : "pointer",
                                color:
                                  index === drawerOrders.length - 1 ||
                                  isRemovingOrder
                                    ? "#d1d5db"
                                    : "#111827"
                              }}
                            >
                              <ArrowDownwardIcon fontSize="small" />
                            </button>
                          </div>

                          <IconButton
                            size="small"
                            title="Rimuovi ordine dal lotto"
                            onClick={() => handleRemoveOrderFromLotto(o)}
                            disabled={
                              !orderLotto ||
                              !o.idDocumento ||
                              isRemovingOrder ||
                              saving
                            }
                            sx={{
                              color: "#dc2626",
                              "&:hover": {
                                backgroundColor: "#fee2e2"
                              },
                              "&.Mui-disabled": {
                                color: "#d1d5db"
                              }
                            }}
                          >
                            {isRemovingOrder ? (
                              <CircularProgress size={18} color="inherit" />
                            ) : (
                              <DeleteOutlineIcon fontSize="small" />
                            )}
                          </IconButton>

                        </div>
                      </div>
                    );
                    })}
                  </div>
                )}

                <Divider className="my-4" />

                {/* MULTI SELECT OPERAI */}
                <Autocomplete
                  multiple
                  options={workers}
                  value={assignedWorkers}
                  onChange={handleWorkerChange}
                  getOptionLabel={(w) => w.name}
                  renderInput={(params) => (
                    <TextField {...params} label="Assegna operai" />
                  )}
                  sx={{ marginBottom: "1.5rem", marginTop: "1.5rem" }}
                />

                {/* ---------------- DOCUMENTI PDF ---------------- */}
                <div style={{ marginBottom: "1.5rem" }}>
                  <h3 className="text-md font-semibold text-gray-700 mb-2">
                    Documenti
                  </h3>

                  <List dense sx={{
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    padding: "0.5rem"
                  }}>
                    {availablePdfs.map((pdf) => {
                    console.log("PDF", pdf);
                    const ordineAssociato = getPdfOrderReference(pdf);
                    return(
                      <ListItem
                        key={pdf.id}
                        disablePadding
                        secondaryAction={
                          <div style={{ display: "flex", alignItems: "center" }}>

                            {/* 👁️ PREVIEW PDF */}
                            <IconButton
                              edge="end"
                              onClick={(e) => {
                                e.stopPropagation();   // ⛔ evita toggle checkbox
                                openPdf(pdf);
                              }}
                              title="Anteprima PDF"
                            >
                              <VisibilityIcon color="primary" />
                            </IconButton>

                            {/* ☑️ CHECKBOX */}
                            <Checkbox
                              edge="end"
                              checked={selectedPdfs.includes(pdf.id)}
                              onChange={() => handleTogglePdf(pdf.id)}
                            />
                          </div>
                        }
                      >
                        <ListItemButton onClick={() => handleTogglePdf(pdf.id)}>
                          <ListItemText
                            primary={
                              <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                <PictureAsPdfIcon color="error" />
                                {pdf.filePdf}
                              </span>
                            }
                            secondary={
                                <>
                                  {ordineAssociato && (
                                    <div
                                      style={{
                                        marginTop: "0.25rem",
                                        color: "#16a34a",
                                        fontWeight: 500
                                      }}
                                    >
                                      Aggiunto all'ordine {ordineAssociato}
                                    </div>
                                  )}

                                  <div>{pdf.descrizione}</div>

                                  {pdf.note && (
                                    <div
                                      style={{
                                        marginTop: "0.25rem",
                                        fontStyle: "italic",
                                        color: "#6b7280"
                                      }}
                                    >
                                      Nota: {pdf.note}
                                    </div>
                                  )}
                                </>
                              }
                          />
                        </ListItemButton>
                      </ListItem>
                      );
                    })}
                  </List>
                </div>

                {/* ---------------- NUOVO UPLOAD PDF PREMIUM ---------------- */}
                <Divider className="my-4" />

                <div style={{ marginBottom: "2rem" }}>
                  <h3 className="text-md font-semibold text-gray-700 mb-3">
                    Aggiungi nuovi documenti
                  </h3>

                  {/* Area selezione file */}
                  <div
                    style={{
                      border: "2px dashed #cbd5e1",
                      borderRadius: "12px",
                      padding: "1.5rem",
                      textAlign: "center",
                      backgroundColor: "#f8fafc",
                      marginBottom: "1rem",
                      cursor: "pointer",
                      transition: "border-color 0.2s" // piccolo effetto smooth
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#16a34a"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#cbd5e1"; }}
                  >

                    <input
                      type="file"
                      accept="application/pdf"
                      multiple
                      onChange={handleFileSelection}
                      style={{ display: "none" }}
                      id="pdfUploadInput"
                    />

                    <label htmlFor="pdfUploadInput" style={{ cursor: "pointer" }}>
                      <div style={{ fontSize: "2rem" }}>📂</div>
                      <div style={{ fontWeight: 500 }}>
                        Clicca per selezionare uno o più PDF
                      </div>
                      <div style={{ fontSize: "0.85rem", color: "#64748b" }}>
                        Ogni file potrà avere una nota dedicata
                      </div>
                    </label>
                  </div>

                  {/* Lista file selezionati */}
                  {newFiles.length > 0 && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      {newFiles.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            border: "1px solid #e2e8f0",
                            borderRadius: "12px",
                            padding: "1rem",
                            backgroundColor: "white",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "0.5rem"
                            }}
                          >
                            <div style={{ fontWeight: 600 }}>
                              📄 {item.file.name}
                            </div>

                            <button
                              onClick={() => handleRemoveFile(index)}
                              style={{
                                backgroundColor: "#fee2e2",
                                color: "#dc2626",
                                border: "none",
                                padding: "0.3rem 0.6rem",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "0.8rem"
                              }}
                            >
                              Rimuovi
                            </button>
                          </div>

                          <TextField
                            select
                            fullWidth
                            label="Associa a ordine"
                            value={item.idDocumento}
                            onChange={(e) =>
                              handleDocumentoChange(index, e.target.value)
                            }
                            SelectProps={{ native: true }}
                            sx={{ mb: 2 }}
                          >
                            {selectedOrders.map(order => (
                              <option
                                key={order.idDocumento}
                                value={order.idDocumento}
                              >
                                {order.tipoDoc} {order.numDoc} - {order.ragioneSocialeCliente}
                              </option>
                            ))}
                          </TextField>

                          <TextField
                            label="Nota per questo documento"
                            fullWidth
                            multiline
                            rows={2}
                            value={item.note}
                            onChange={(e) =>
                              handleNoteChange(index, e.target.value)
                            }
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Bottone upload */}
                  {newFiles.length > 0 && (
                    <>
                      {/* Feedback quantità documenti */}
                      <div
                        style={{
                          marginTop: "1rem",
                          fontSize: "0.85rem",
                          color: "#64748b",
                          textAlign: "center"
                        }}
                      >
                        {newFiles.length === 1
                          ? "1 documento pronto per il caricamento"
                          : `${newFiles.length} documenti pronti per il caricamento`}
                      </div>

                      <Button
                        variant="contained"
                        color="success"
                        fullWidth
                        startIcon={!uploading && <CloudUploadIcon />}
                        onClick={handleUploadReports}
                        disabled={uploading}
                        sx={{
                          mt: 2,
                          py: 1.2,
                          borderRadius: 3,
                          textTransform: "none",
                          fontWeight: 600
                        }}
                      >
                        {uploading ? (
                          <>
                            <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />
                            Caricamento...
                          </>
                        ) : (
                          newFiles.length === 1
                            ? "Carica documento"
                            : `Carica ${newFiles.length} documenti`
                        )}
                      </Button>

                    </>
                  )}

                </div>


                {/* PROTOCOL NUMBER */}
                <TextField
                  label="Lotto di produzione"
                  fullWidth
                  value={protocolNumber}
                  sx={{ marginBottom: "1.5rem" }}
                  InputProps={{
                      readOnly: true,
                      style: { fontWeight: 'bold', fontSize: '1.2rem', color: 'black' } // grassetto e dimensione testo
                    }}
                />

                {/* SAVE BUTTON */}
                <button
                  type="button"
                  onClick={handleSave}
                  disabled={saving}   // ⛔ disabilitato se sta salvando
                  style={{
                    backgroundColor: saving ? "#93c5fd" : "#2563eb",
                    cursor: saving ? "not-allowed" : "pointer",
                    color: "white",
                    padding: "0.75rem 1.5rem",
                    borderRadius: "8px",
                    border: "none",
                    width: "100%",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.75rem"
                  }}
                >
                  {saving ? (
                    <>
                      <CircularProgress size={22} color="inherit" />
                      Salvataggio...
                    </>
                  ) : (
                    "Salva assegnazione"
                  )}
                </button>

                {hasExistingLotto && (
                  <button
                    type="button"
                    onClick={async () => {
                      if (showAddOrders) {
                        setShowAddOrders(false);
                        setLoadingAdditionalOrders(false);
                        setAdditionalOrdersSearch("");
                        return;
                      }

                      setShowAddOrders(true);
                      setAdditionalOrdersSearch("");
                      setLoadingAdditionalOrders(true);
                      try {
                        const data = await availableOrdersToAdd();
                        setAdditionalOrders(Array.isArray(data) ? data : []);
                      } finally {
                        setLoadingAdditionalOrders(false);
                      }
                    }}
                    style={{
                      backgroundColor: "#16a34a",
                      color: "white",
                      padding: "0.75rem 1.5rem",
                      borderRadius: "8px",
                      border: "none",
                      width: "100%",
                      fontWeight: "600",
                      marginTop: "0.75rem"
                    }}
                  >
                    {showAddOrders ? "Chiudi aggiunta ordini" : "+ Aggiungi Ordini"}
                  </button>
                )}

                {showAddOrders && (
                  <div
                    style={{
                      marginTop: "1rem",
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      padding: "1rem",
                      backgroundColor: "#f9fafb"
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: 600,
                        marginBottom: "1rem",
                        color: "#111827"
                      }}
                    >
                      Ordini disponibili da aggiungere
                    </h3>

                    <TextField
                      label="Cerca per ragione sociale, numero doc o cliente"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={additionalOrdersSearch}
                      onChange={(e) => setAdditionalOrdersSearch(e.target.value)}
                      sx={{ marginBottom: "1rem" }}
                    />

                    {loadingAdditionalOrders ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.75rem",
                          color: "#6b7280",
                          padding: "1rem"
                        }}
                      >
                        <CircularProgress size={20} />
                        <span>Caricamento ordini...</span>
                      </div>
                    ) : additionalOrders.length === 0 ? (
                      <p style={{ color: "#6b7280" }}>
                        Nessun ordine disponibile
                      </p>
                    ) : filteredAdditionalOrders.length === 0 ? (
                      <p style={{ color: "#6b7280" }}>
                        Nessun ordine trovato con questo filtro
                      </p>
                    ) : (
                      <List dense>
                        {filteredAdditionalOrders.map(order => {
                          const checked = selectedAdditionalOrders.some(
                            o => o.idDocumento === order.idDocumento
                          );

                          return (
                            <ListItem
                              key={order.idDocumento}
                              disablePadding
                              secondaryAction={
                                <Checkbox
                                  checked={checked}
                                  onChange={() => {
                                    setSelectedAdditionalOrders(prev => {
                                      if (
                                        prev.some(
                                          o => o.idDocumento === order.idDocumento
                                        )
                                      ) {
                                        return prev.filter(
                                          o => o.idDocumento !== order.idDocumento
                                        );
                                      }

                                      return [...prev, order];
                                    });
                                  }}
                                />
                              }
                            >
                              <ListItemButton
                                onClick={() => {
                                  setSelectedAdditionalOrders(prev => {
                                    if (
                                      prev.some(
                                        o => o.idDocumento === order.idDocumento
                                      )
                                    ) {
                                      return prev.filter(
                                        o => o.idDocumento !== order.idDocumento
                                      );
                                    }

                                    return [...prev, order];
                                  });
                                }}
                              >
                                <ListItemText
                                  primary={`${order.tipoDoc} ${order.numDoc}`}
                                  secondary={`${order.idCliente} - ${order.ragioneSocialeCliente}`}
                                />
                              </ListItemButton>
                            </ListItem>
                          );
                        })}
                      </List>
                    )}
                    <Button
                      variant="contained"
                      color="success"
                      fullWidth
                      sx={{
                        mt: 2,
                        borderRadius: 3,
                        textTransform: "none",
                        fontWeight: 600
                      }}
                      onClick={handleAddOrdersToLotto}
                      disabled={saving}
                    >
                      {saving
                        ? "Salvataggio..."
                        : `Aggiungi ${selectedAdditionalOrders.length} ordini`}
                    </Button>
                  </div>
                )}

                {(() => {
                  const lotti = [...new Set(
                    drawerOrders.map(o => o.lotto)
                  )].filter(v => v != null);

                  const canUnassign =
                    drawerOrders.length > 0 &&
                    lotti.length === 1;

                  return canUnassign && (
                    <button
                      type="button"
                      onClick={handleUnassign}
                      disabled={saving}
                      style={{
                        backgroundColor: saving ? "#fca5a5" : "#dc2626",
                        cursor: saving ? "not-allowed" : "pointer",
                        color: "white",
                        padding: "0.75rem 1.5rem",
                        borderRadius: "8px",
                        border: "none",
                        width: "100%",
                        fontWeight: "600",
                        marginTop: "0.75rem"
                      }}
                    >
                      Annulla assegnazione
                    </button>
                  );
                })()}

              </div>
            </Drawer>
          </div>
        </Container>
    </>
  );
}
